module.exports = __webpack_public_path__ + "b69f3e4c860841e03922787ef4994241.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/floatie-watermelon.png
// module id = 1845
// module chunks = 0